import Api from "../../utils/api";
import Endpoints from "../../core/config/Endpoints";

export class CardService {
    async get(id) {
        const token = localStorage.getItem("token");
        if (!token) {
            return null;
        }
        const response = await Api.get(`${Endpoints.card}/${id}`, {
            "Content-Type": "application/json",
            Authorization: token,
        });

        return response ?? null;
    }
}